import {Component, Input, OnInit, ViewChild, Output, EventEmitter} from '@angular/core';
import { Linqset, LinqsetEdge, LinqsetNode, NODE_SUPERTYPE, NODE_TYPE, actionTempoDescription, capacityDescription, durationEquals, frequencyEquals, getInsights, isRolePeople, isSystemInfrastructure, stringArraysEqual } from '../../common/linqset-model';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

interface NodeChange {
    type:NODE_TYPE
    name:string
    field:string
    before:any
    after:any
}

/**
 * @title List with selection
 */
@Component({
    selector: 'app-project-details',
    styleUrls: ['project-details.css'],
    templateUrl: 'project-details.html',
    standalone: false
})
export class ProjectDetailsComponent  implements OnInit {
    @Input() refreshTrigger:any
    @Input() linqset: Linqset
    @Input() comparison:Linqset

    newEdges:LinqsetEdge[]

    public createdNodesColumns = ['type', 'name', 'field', 'before', 'after'];
    public createdNodesSource = new MatTableDataSource<NodeChange>();
    public deletedNodesColumns = ['type', 'name'];
    public deletedNodesSource = new MatTableDataSource();

    @ViewChild(MatSort) sort!: MatSort;

    @Output() selectEdgeEvent = new EventEmitter<LinqsetEdge>();
     
    constructor() {
    }

    ngOnChanges(changes) {
        if (changes["linqset"] || changes['comparison'] || changes["refreshTrigger"])
            this.ngAfterViewInit()
    }

    ngAfterViewInit() {
        if (!this.comparison) return

        this.deletedNodesSource.data = this.comparison.nodes.reduce((a:any, n:LinqsetNode) => {
            if (!this.linqset.nodes.find(n2 => n2._key === n._key)) {
                a.push({name:n.name, superType:n.superType, type:n.type})
            }

            return a
        }, [])


        this.createdNodesSource.data = this.linqset.nodes.reduce((a, n) => {
            const comparisonNode = this.comparison.getNode(n._key)

            if (comparisonNode?.currentState) {
                if (n.superType === NODE_SUPERTYPE.INFORMATION) {
                    const insights = getInsights(n, this.linqset)
                    if (insights.isOutput) {
                        if ((comparisonNode.currentState.outputValue || 0) !== (n.properties.outputValue || 0)) {
                            a.push(this.createNodeChange(n, "Output value", comparisonNode.currentState.outputValue, n.properties.outputValue))
                        }
                        if ((comparisonNode.currentState.outputRevenue || 0) !== (n.properties.outputRevenue || 0)) {
                            a.push(this.createNodeChange(n, "Output revenue", comparisonNode.currentState.outputRevenue, n.properties.outputRevenue))
                        }
                    }
                }
                if (n.superType === NODE_SUPERTYPE.INFRASTRUCTURE) {
                    if ((comparisonNode.currentState.units || 0) !== (n.properties.units || 0))
                        a.push(this.createNodeChange(n, "Num units", comparisonNode.currentState.units, n.properties.units))

                    if ((comparisonNode.currentState.unitCost || 0) !== (n.properties.unitCost || 0))
                        a.push(this.createNodeChange(n, "Unit cost", comparisonNode.currentState.annualCost, n.properties.annualCost))

                    if ((comparisonNode.currentState.lifetime || 0) !== (n.properties.lifetime || 0))
                        a.push(this.createNodeChange(n, "Life time", comparisonNode.currentState.lifetime, n.properties.lifetime))

                    if (!stringArraysEqual(comparisonNode.currentState.emissions && comparisonNode.currentState.emissions.map(e => e._key), n.properties.emissions && n.properties.emissions.map(e => e._key))) {
                        a.push(this.createNodeChange(n, "Emissions", "",""))
                    }

                }
                if (n.superType === NODE_SUPERTYPE.ACTION || isRolePeople(n.superType)) {
                    if (!durationEquals(comparisonNode.currentState.duration, n.properties.duration) || !frequencyEquals(comparisonNode.currentState.frequency, n.properties.frequency)) {
                        if (n.superType === NODE_SUPERTYPE.ACTION) {
                            a.push(this.createNodeChange(n, "Load", actionTempoDescription(comparisonNode.currentState), actionTempoDescription(n.properties)))
                        }else {
                            a.push(this.createNodeChange(n, "Capacity", capacityDescription(comparisonNode.currentState), capacityDescription(n.properties)))
                        }
                    }
                }

                if (isRolePeople(n.superType) || isSystemInfrastructure(n.superType)) {
                    if ((comparisonNode.currentState.hourlyCost || 0) !== (n.properties.hourlyCost || 0))
                        a.push(this.createNodeChange(n, "Hourly cost", comparisonNode.currentState.hourlyCost, n.properties.hourlyCost))
                    if ((comparisonNode.currentState.annualCost || 0) !== (n.properties.annualCost || 0))
                        a.push(this.createNodeChange(n, "Annual cost per person", comparisonNode.currentState.annualCost, n.properties.annualCost))

                    if ((comparisonNode.currentState.people || 0) !== (n.properties.people || 0))
                        a.push(this.createNodeChange(n, "Num people", comparisonNode.currentState.people, n.properties.people))

                    if ((comparisonNode.currentState.fixedCost || 0) !== (n.properties.fixedCost || 0))
                        a.push(this.createNodeChange(n, "Annual cost", comparisonNode.currentState.fixedCost, n.properties.fixedCost))

                }

            }else if (n.projectKey === this.linqset.workspaceKey) {
                a.push({
                    type:n.type,
                    name:n.name,
                    field:'New node'
                })
            }
            return a
        }, [])
        this.createdNodesSource.sort = this.sort;

        this.newEdges = []
    }

    private createNodeChange(n:LinqsetNode, field:string, before:any, after:any) {
        return {
            type:n.type,
            name:n.name,
            field:field,
            before:before,
            after:after
        }
    }

    ngOnInit(): void {
    }

    selectNode(node) {}

}